module.exports = __webpack_public_path__ + "img/@work_trueEtn_list.f087aa10.jpg";